<template>
  <div class="lg:px-20 md:px-12 px-5 lg:py-20 md:py-16 py-12 bg-primary">
    <div class="text-center w-70per sm-wfull mx-auto">
      <h2 class="fsize30 sm-fsize22 font-semibold lg:mb-6 mb-4 clr-fff">
        Want Tailored Support For Your Organization?
      </h2>
      <p class="mb-4 clr-fff sm-fsize14">
        We understand that the needs of organisations differ depending on your
        company size, values and goals. Which is why we offer customised
        offerings that suits your specific requirements, making them relevant,
        impactful, and objective-driven.
      </p>
      <button
        class="rounded-full py-2 px-4 clr-fff bdr-fff sm-fsize14"
        @click="
          handleRoute('request-form', 'corporate-services-customisedproject')
        "
      >
        <!-- <a
          href="mailto:info@caregiversaathi.co.in"
          v-smooth-scroll="{ duration: 1000, offset: -10 }"
        > -->
        Get a Custom Offering
        <!-- </a> -->
      </button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleScroll() {
      const el = document.getElementById("corporateForm");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    handleRoute(name, route) {
      this.$router.push({
        name: name,
        params: {
          pathName: route,
        },
      });
    },
  },
  computed: {},
  mounted() {},
};
</script>
<style>
.w-70per {
  width: 70%;
}
.bdr-fff a:hover {
  color: white;
}

.bdr-fff a:hover {
  color: white;
}
</style>
